module.exports = __webpack_public_path__ + "img/play-post-2.cc11b577.jpg";